/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/AdvertismentPictures/Astravelis_BG.png";
import LogoAstravelisIcon from "assets/images/Logo/Astravelis/Logo.png";
import WithlistOnSteam from "assets/images/AdvertismentPictures/WithlistOnSteam.png";
import CharacterSelection from "assets/images/Astravelis/Character Selection.png";
import ExploreLevels from "assets/images/Astravelis/ExploreLevels.png";
import Shop from "assets/images/Astravelis/Shop.png";
import ExplorationDay from "assets/images/Astravelis/Exploration_Day.png";
import ExplorationNight from "assets/images/Astravelis/Exploration_Night.png";
import Combat from "assets/images/Astravelis/Combat.png";

function Astravelis() {
  return (
    <>
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
          mb: 4,
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} mt={15} mb={10} justifyContent="center" mx="auto">
            <Card
              sx={{
                backgroundColor: () => `rgba(255, 255, 255, 0.9)`,
                borderRadius: "15px",
                p: 6,
                boxShadow: 3,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <MKTypography
                variant="h1"
                color="black"
                textAlign="center"
                mb={4}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Astravelis{" "}
              </MKTypography>
              <MKTypography
                variant="body1"
                color="black"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={2}
                mb={4}
              >
                Explore the world of Astravelis, a new RPG adventure game. Coming soon on Steam.
              </MKTypography>
            </Card>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 4,
          mx: { xs: 3, lg: 6 },
          mt: -10, // Increased negative margin to move card higher
          mb: 6,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MKTypography variant="h3" mb={4}>
                Spiele Astravelis
              </MKTypography>
              <MKTypography variant="body2" color="text" mb={4}>
                Astravelis is a combination of idle game and RPG. Choose an adventure and let your
                character fight automatically. Choose between different areas in which your
                adventure explores and encounters both enemies and objects to collect. Collect
                equipment and upgrade your character to defeat stronger opponents.
              </MKTypography>
              <MKTypography variant="body2" color="text" mb={4}>
                Check it out now and see for yourself with the demo of Astravelis.
              </MKTypography>
              <MKButton
                variant="gradient"
                size="small"
                component="a"
                href=""
                target="_blank"
                circular="true"
                sx={{
                  mb: 2,
                  mr: 2,
                  "& img": {
                    width: "200px",
                    height: "auto",
                  },
                }}
              >
                <img src={WithlistOnSteam} alt="Wishlist on Steam" />
              </MKButton>
              <MKButton
                variant="gradient"
                size="small"
                component="a"
                href="https://play.google.com/store/apps/details?id=com.LKGameArt.Astravelis"
                target="_blank"
                sx={{
                  mb: 2,
                  mr: 2,
                  "& img": {
                    width: "200px",
                    height: "auto",
                  },
                }}
              >
                <img
                  alt="Get it on Google Play"
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/de_badge_web_generic.png"
                />
              </MKButton>
              <MKButton
                variant="gradient"
                size="small"
                component="a"
                href="https://onedrive.live.com/redir.aspx?cid=7a5affb1441e837f&resid=7A5AFFB1441E837F!442248&parId=7A5AFFB1441E837F!442215&authkey=!ANF8j-Z5QOaFVMg"
                target="_blank"
                sx={{
                  mb: 2,
                  mr: 2,
                }}
              >
                Download Demo
              </MKButton>
            </Grid>
            <Grid item xs={12} lg={6}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <MKBox
                    component="img"
                    src={LogoAstravelisIcon}
                    alt="Astravelis Logo"
                    width="100%"
                    height="auto"
                    sx={{
                      borderRadius: "60px",
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Card>
      <Card
        sx={{
          p: 4,
          mx: { xs: 3, lg: 6 },
          mb: 6,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <MKTypography variant="h1" mb={4}>
            Trailer
          </MKTypography>
          <MKBox
            component="iframe"
            title="Astravelis Trailer"
            src="https://www.youtube.com/embed/YOUR_VIDEO_ID"
            width="100%"
            height="600px"
            sx={{
              border: "none",
              borderRadius: "12px",
              boxShadow: 2,
            }}
          />
        </Container>
      </Card>
      <Card
        sx={{
          p: 4,
          mx: { xs: 3, lg: 6 },
          mb: 6,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <MKTypography variant="h1" mb={4}>
            About the game
          </MKTypography>
          <Grid container spacing={4} mb={12}>
            <Grid item xs={12} md={4}>
              <DefaultInfoCard
                icon="person"
                title="1. Create Your Hero"
                description="Choose your character which you want to play."
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DefaultInfoCard
                icon="sports_kabaddi"
                title="2. Auto-Battle System"
                description="Watch your hero automatically fight monsters and gain experience. Collect loot, equipment, and resources while you're away."
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <DefaultInfoCard
                icon="upgrade"
                title="3. Progress & Upgrade"
                description="Use collected resources to upgrade your gear, unlock new abilities, and become more powerful. The longer you play, the stronger you get!"
              />
            </Grid>
          </Grid>
          <MKTypography variant="h1" mb={4}>
            Gameplay
          </MKTypography>
          <Grid container spacing={4}>
            <Grid item xs={12} container alignItems="center" mb={4}>
              <Grid item xs={12} md={6} pr={4}>
                <MKTypography variant="h3" mb={2}>
                  1. Character selection
                </MKTypography>
                <MKTypography variant="body1">
                  Select your character which you want to play. There are 13 different characters to
                  select. The characters are all the same, but in the future they will have
                  different abilities and skills.
                </MKTypography>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox component="img" src={CharacterSelection} width="100%" borderRadius="lg" />
              </Grid>
            </Grid>

            <Grid item xs={12} container alignItems="center" mb={4}>
              <Grid item xs={12} md={6}>
                <MKBox component="img" src={ExploreLevels} width="100%" borderRadius="lg" />
              </Grid>
              <Grid item xs={12} md={6} pl={4}>
                <MKTypography variant="h3" mb={2}>
                  2. Expore the diffent levels and fight against monsters
                </MKTypography>
                <MKTypography variant="body1">
                  The demo has 4 different levels. Each level has different monsters and different
                  loot. The first levels are all about goblins. The yellow stars of each level shows
                  the difficulty of the level. The more stars, the more difficult the level. When
                  you explore a level, your character will search this area and will fight against
                  the monsters. The monsters drop loot and experience points. The experience points
                  are used to level up your character. The loot can be used to upgrade your
                  character or to sell it.
                </MKTypography>
              </Grid>
            </Grid>

            <Grid item xs={12} container alignItems="center" mb={4}>
              <Grid item xs={12} md={6} pr={4}>
                <MKTypography variant="h3" mb={2}>
                  3. The shop
                </MKTypography>
                <MKTypography variant="body1">
                  Buy new equipment and upgrade your character. Every day or every time your
                  character levels up, you can buy new equipment. So always keep an eye on the shop.
                  Or you could miss out on a great deal.
                </MKTypography>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox component="img" src={Shop} width="100%" borderRadius="lg" />
              </Grid>
            </Grid>

            <Grid item xs={12} container alignItems="center" mb={4}>
              <Grid item xs={12} md={6}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <MKBox component="img" src={ExplorationDay} width="100%" borderRadius="lg" />
                  </Grid>
                  <Grid item xs={12}>
                    <MKBox component="img" src={ExplorationNight} width="100%" borderRadius="lg" />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6} pl={4}>
                <MKTypography variant="h3" mb={2}>
                  4. Explore Day and Night
                </MKTypography>
                <MKTypography variant="body1">
                  Experience the world of Astravelis at day or night. You can find different
                  monsters and loot during the day and at night. So always keep an eye on the time.
                  The time is shown in the top right corner of the screen. The day is from 8:00 to
                  20:00 and the night is from 20:00 to 8:00. Allways be prepared for a fight. At
                  both day and night you will encounter monsters and you need to fight against them.
                  The monsters drop loot, money and experience points. The experience points are
                  used to level up your character. The loot can be used to upgrade your character or
                  to sell it. The money can be used to buy new equipment.
                </MKTypography>
              </Grid>
            </Grid>
            <Grid item xs={12} container alignItems="center" mb={4}>
              <Grid item xs={12} md={6} pr={4}>
                <MKTypography variant="h3" mb={2}>
                  5. The combat system
                </MKTypography>
                <MKTypography variant="body1">
                  Astravelis is an idle game. This means that your character fights automatically.
                  But you can select the target you want to attack first. If you don&apos;t select a
                  target, your character will attack the first monster in the list. So it will will
                  the enemys from top to bottom. To increase you survival rate you can buy new
                  equipment and upgrade your character. The combat system is realtime. Your
                  character and the monsters attack each other at the same time. Each character has
                  a different attack speed, attack damage, chrit rate usw. There are many different
                  stats which can be upgraded.
                </MKTypography>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox component="img" src={Combat} width="100%" borderRadius="lg" />
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Card>
      <DefaultFooter content={footerRoutes} />
    </>
  );
}

export default Astravelis;
